import { Component, EventEmitter, Inject, Input, OnInit, Output, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { BundleType, DateRangeFilterOption, EntityTypeId, FieldName, ImageModel } from '../../../common/models';
import { LibraryType } from '../../../models';
import { LibraryItem } from '../../models';
import { FileExtensionService } from '../../services/file-extension/file-extension.service';
import { DateRangeFilterService } from '../../../common/services/date-range-filter.service';
import { BaseSettingsGetService } from '../../../common/services';
import { SETTINGS_SERVICE } from '../../../common/constants';

@Component({
    selector: 'lib-library-item-card',
    templateUrl: './library-item-card.component.html',
    styleUrls: ['./library-item-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LibraryItemCardComponent implements OnInit {
  @Input() public item: LibraryItem;
  @Input() public contextTemplate: TemplateRef<any>;

  public libraryTypes: typeof LibraryType = LibraryType;

  @Output() public open: EventEmitter<void> = new EventEmitter<void>();

  public previewImage: ImageModel;
  public isNew = false;
  public hideUpdatedDate = false;

  public readonly entityTypeId: typeof EntityTypeId = EntityTypeId;
  public readonly bundleType: typeof BundleType = BundleType;
  public fieldName: FieldName = FieldName.AWS_FILE;

  constructor(
    private readonly fileExtensionService: FileExtensionService,
    private readonly dateRangeFilterService: DateRangeFilterService,
    @Inject(SETTINGS_SERVICE) private readonly settingsService: BaseSettingsGetService,
  ) { }

  ngOnInit(): void {
    this.previewImage = this.fileExtensionService.getLibraryItemPreviewImage(this.item);
    this.fieldName = this.item?.mediaImage ? FieldName.MEDIA_IMAGE : FieldName.AWS_FILE;
    const LAST_7_DAYS = this.dateRangeFilterService.mapRangeOptionToDates(DateRangeFilterOption.LAST_7_DAYS);
    this.isNew = new Date(LAST_7_DAYS.start).getTime() < new Date(this.item.updated).getTime();
    this.settingsService.getSettings().subscribe(settings => {
      this.hideUpdatedDate = settings.library?.removeUpdatedDateFromCard;
    })
  }

  public openLibraryItem(): void {
    this.open.emit();
  }

  public stopPropagation(event: Event) {
    event.stopPropagation();
    event.preventDefault();
  }

}
